import React, { useState } from 'react';
import { css } from '@emotion/react';
import { Grid, TextField, MenuItem, InputAdornment, ListSubheader } from '@material-ui/core';
import { Body1 } from './blocks';
import { MARKETPLACE_TIER_DISPLAYS } from './constants';

export const COLUMNS = [
    {
        Header: 'Data',
        id: 'data-columns',
        columns: [
            {
                Header: 'Name',
                id: 'name',
                accessor: (option) => option.name,
            },
            {
                Header: 'Flat Margin',
                id: 'add_margin_flat',
                span: false,
                Cell: ({ row, callbacks }) => {
                    const [temp, setTemp] = useState(row.original.add_margin_flat);

                    return (
                        <Grid
                            container
                            direction="row"
                            css={css`
                                height: 100%;
                                align-items: center;
                                flex-wrap: nowrap;
                            `}
                        >
                            <TextField
                                disabled={row.original.read_only}
                                variant="outlined"
                                size="small"
                                value={temp !== null && temp !== undefined ? temp : row.original.add_margin_flat || 0}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">$</InputAdornment>,
                                }}
                                onChange={(e) => {
                                    setTemp(e.target.value !== '' ? e.target.value : 0);
                                }}
                                onBlur={(e) => {
                                    callbacks.setOverride({
                                        name: row.original.id,
                                        attr: 'add_margin_flat',
                                        value: parseFloat(e.target.value),
                                    });
                                }}
                                fullWidth
                            />
                        </Grid>
                    );
                },
            },
            {
                Header: 'Margin Rate',
                id: 'add_margin_rate',
                span: false,
                Cell: ({ row, callbacks }) => {
                    const [temp, setTemp] = useState(row.original.add_margin_rate);

                    return (
                        <Grid
                            container
                            direction="row"
                            css={css`
                                height: 100%;
                                align-items: center;
                                flex-wrap: nowrap;
                            `}
                        >
                            <TextField
                                disabled={row.original.read_only}
                                variant="outlined"
                                size="small"
                                value={
                                    (temp !== null && temp !== undefined ? temp : row.original.add_margin_rate || 0) *
                                    100
                                }
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                }}
                                onChange={(e) => {
                                    setTemp(e.target.value !== '' ? parseFloat(e.target.value) / 100 : 0);
                                }}
                                onBlur={(e) => {
                                    callbacks.setOverride({
                                        name: row.original.id,
                                        attr: 'add_margin_rate',
                                        value: parseFloat(e.target.value) / 100,
                                    });
                                }}
                                fullWidth
                            />
                        </Grid>
                    );
                },
            },
            {
                Header: 'Zip Filter',
                id: 'zip_geofence',
                span: false,
                Cell: ({ row, callbacks }) => {
                    if (row.original.name === 'Marketplace') {
                        return (
                            <Grid
                                container
                                direction="row"
                                css={css`
                                    height: 100%;
                                    align-items: center;
                                    justify-content: center;
                                    flex-wrap: nowrap;
                                `}
                            >
                                <Body1>{'N/A'}</Body1>
                            </Grid>
                        );
                    }

                    return (
                        <Grid
                            container
                            direction="row"
                            css={css`
                                height: 100%;
                                align-items: center;
                                flex-wrap: nowrap;
                            `}
                        >
                            <TextField
                                disabled={row.original.read_only}
                                select
                                variant="outlined"
                                size="small"
                                value={row.original.zip_geofence}
                                onChange={(e) => {
                                    callbacks.setOverride({
                                        name: row.original.id,
                                        attr: 'zip_geofence',
                                        value: e.target.value,
                                    });
                                }}
                                fullWidth
                            >
                                <MenuItem key={0} value={true}>
                                    <Body1>Yes</Body1>
                                </MenuItem>
                                <MenuItem key={1} value={false}>
                                    <Body1>No</Body1>
                                </MenuItem>
                            </TextField>
                        </Grid>
                    );
                },
            },
            {
                Header: 'Tariff',
                id: 'tariff_id',
                span: false,
                Cell: ({ row, callbacks }) => {
                    return (
                        <Grid
                            container
                            direction="row"
                            css={css`
                                height: 100%;
                                align-items: center;
                                flex-wrap: nowrap;
                            `}
                        >
                            <Grid
                                container
                                direction="column"
                                css={css`
                                    height: 100%;
                                    align-items: center;
                                    flex-wrap: nowrap;
                                    justify-content: space-between;
                                `}
                            >
                                <Grid container direction="row">
                                    <TextField
                                        select
                                        error={row.original.name === 'Marketplace' && !row.original.tariff_id}
                                        disabled={
                                            (row?.original?.admin_tariff_options?.length === 0 &&
                                                row?.original?.client_tariff_options?.length === 0) ||
                                            row.original.read_only
                                        }
                                        variant="outlined"
                                        size="small"
                                        label="Shipper Tariff"
                                        value={row.original.tariff_id || ''}
                                        onChange={(e) => {
                                            callbacks.setOverride({
                                                name: row.original.id,
                                                attr: 'tariff_id',
                                                value: e.target.value,
                                            });

                                            callbacks.setOverride({
                                                name: row.original.id,
                                                attr: 'carrier_tariff_id',
                                                value: e.target.value,
                                            });
                                        }}
                                        fullWidth
                                    >
                                        {[
                                            {
                                                label: `Admin Tariffs (${row?.original?.algo_type})`,
                                                attr: 'admin_tariff_options',
                                            },
                                            {
                                                label: `Carrier Tariffs (${row?.original?.algo_type})`,
                                                attr: 'client_tariff_options',
                                            },
                                        ]
                                            .filter(({ attr }) => row?.original?.[attr]?.length > 0)
                                            .map(({ label, attr }) => [
                                                <ListSubheader>{label}</ListSubheader>,
                                                ...(row?.original?.[attr] || []).map(({ label, value }) => (
                                                    <MenuItem key={value} value={value}>
                                                        <Body1>{label}</Body1>
                                                    </MenuItem>
                                                )),
                                            ])}
                                    </TextField>
                                </Grid>
                                {row.original.name !== 'Marketplace' && (
                                    <Grid container direction="row">
                                        <TextField
                                            select
                                            error={
                                                row.original.requires_carrier_tariff && !row.original.carrier_tariff_id
                                            }
                                            disabled={
                                                (row?.original?.admin_tariff_options?.length === 0 &&
                                                    row?.original?.client_tariff_options?.length === 0) ||
                                                row.original.read_only
                                            }
                                            variant="outlined"
                                            size="small"
                                            label="Carrier Tariff"
                                            value={row.original.carrier_tariff_id || ''}
                                            onChange={(e) => {
                                                callbacks.setOverride({
                                                    name: row.original.id,
                                                    attr: 'carrier_tariff_id',
                                                    value: e.target.value,
                                                });
                                            }}
                                            fullWidth
                                        >
                                            {[
                                                {
                                                    label: `Admin Tariffs (${row?.original?.algo_type})`,
                                                    attr: 'admin_tariff_options',
                                                },
                                                {
                                                    label: `Carrier Tariffs (${row?.original?.algo_type})`,
                                                    attr: 'client_tariff_options',
                                                },
                                            ]
                                                .filter(({ attr }) => row?.original?.[attr]?.length > 0)
                                                .map(({ label, attr }) => [
                                                    <ListSubheader>{label}</ListSubheader>,
                                                    ...(row?.original?.[attr] || []).map(({ label, value }) => (
                                                        <MenuItem key={value} value={value}>
                                                            <Body1>{label}</Body1>
                                                        </MenuItem>
                                                    )),
                                                ])}
                                        </TextField>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    );
                },
            },
            {
                Header: 'Tier',
                id: 'marketplace_tier',
                span: false,
                Cell: ({ row, callbacks }) => {
                    return (
                        <Grid
                            container
                            direction="row"
                            css={css`
                                height: 100%;
                                align-items: center;
                                flex-wrap: nowrap;
                            `}
                        >
                            <TextField
                                select
                                error={row.original.name !== 'Marketplace' && !row.original.marketplace_tier}
                                disabled
                                variant="outlined"
                                size="small"
                                value={row.original.marketplace_tier || ''}
                                onChange={(e) => {
                                    callbacks.setOverride({
                                        name: row.original.id,
                                        attr: 'marketplace_tier',
                                        value: e.target.value,
                                    });
                                }}
                                fullWidth
                            >
                                {Object.entries(MARKETPLACE_TIER_DISPLAYS).map(([value, label]) => (
                                    <MenuItem key={value} value={value}>
                                        <Body1>{label}</Body1>
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    );
                },
            },
        ],
    },
];
